module.exports = __webpack_public_path__ + "img/qy_17.png";